<template>
  <div class="page">
    <navigation>一键还款</navigation>
    <div class="main-container">
      <div class="title">
        <div class="title-text">一键还款计划</div>
        <div class="title-desc">
          (当前金额为计划提交金额，请以最终实际扣款金额为准)
        </div>
      </div>
      <div
        class="rights-container"
        @click="pushRightsList"
        data-sensors-click
        v-if="rightsList&& rightsList.length"
      >
        <div
          class="rights-item"
          v-if="!repaying"
        >
          <div class="rights-item-title">您有三方平台消费账单待支付</div>
          <div
            class="rights-item-select"
            :class="{ selected: RightSelected }"
          ></div>
        </div>
        <div
          class="rights-item"
          v-else
        >
          <div class="rights-item-title">您的三方平台消费账单{{ rightsStatus | rightsStatusEnum }}...</div>
        </div>
      </div>
      <div
        class="order-list"
        v-for="billNo in billNoList"
        :key="billNo"
      >
        <div
          class="orderNo"
          @click="$router.push(`/repayment/detail?orderId=${billNo}&loanPlatform=${loanPlatform}&from=true`)"
        >还款账单 {{ billNo }} ></div>
        <div
          class="order-item"
          v-for="item in loanListMap[billNo]"
          :key="item.term + billNo"
        >
          <div
            class="ui-select"
            :class="{ selected: isSelected(item) }"
            v-if="!repaying"
            @click="changeSelect(item)"
          ></div>
          <div class="innerItem">
            <span>期数</span>
            <p>{{item.term }}/{{item.totalTerms }}</p>
          </div>
          <div class="innerItem">
            <span>应还日期</span>
            <p>{{ item.dueDate }}</p>
          </div>
          <div class="innerItem">
            <span>待还金额 (元)</span>
            <p>{{ item.realPaidAmt }}</p>
          </div>
          <div class="innerItem">
            <span>状态</span>
            <p
              :class="{ danger: item.termStatus === 'O' }"
              v-if="!repaying"
            >
              {{ item.termStatus === "O" ? "逾期" : "待还" }}
            </p>
            <p
              v-else
              :class="[item.repayStatus]"
            >{{ item.repayStatus | statusEnum }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="control-container">
      <template v-if="!repaying">
        <div class="flex">
          <div
            class="ui-select"
            :class="{ selected: isAllSelect }"
            @click="selectAll"
          ></div>
          <span>全选</span>
        </div>
        <nd-button
          class="next-btn"
          :disabled="nextStep"
          @click="confirm"
        >下一步</nd-button>
      </template>
      <template v-else>
        <nd-button
          class="pending-btn"
          :disabled="true"
        >受理中</nd-button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      billNoList: [],
      loanList: [],
      loanListMap: {},
      repaying: false,
      selectedList: [],
      rightsStatus: '',
      loanPlatform: '',
      repayExpenseSelect: [],
      rightsList: []
    }
  },
  filters: {
    rightsStatusEnum (value) {
      const map = {
        WAIT: '待支付',
        IN_PROGRESS: '支付中',
        SUCCESS: '已支付'
      }
      return map[value] || value
    },
    statusEnum (value) {
      const map = {
        WAIT: '待还',
        IN_PROGRESS: '还款中',
        PART: '部分成功',
        SUCCESS: '已还'
      }
      return map[value] || value
    }
  },
  computed: {
    isAllSelect () {
      return (
        this.loanList?.length === this.selectedList?.length &&
        this.repayExpenseSelect?.length === this.rightsList?.length
      )
    },
    nextStep () {
      return this.selectedList.length === 0 && !this.RightSelected
    },
    RightSelected () {
      return this.repayExpenseSelect?.length
    }
  },
  mounted () {
    this.info()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('order', ['getRepayBatchListX']),
    async info () {
      const { success, data } = await this.getRepayBatchListX()
      // 还款状态WAIT:待还款IN_PROGRESS:还款中,PART:部分还款成功,SUCCESS:还款成功
      if (success) {
        const {
          selectConsume,
          rightsList = [],
          loanList = [],
          rightsStatus,
          repaying
        } = data
        this.repaying = repaying === 'Y'
        this.rightsStatus = rightsStatus
        // 还款中的数据回显
        if (this.repaying) {
          this.loanList = loanList
          this.rightsList = rightsList
          this.billNoList = Array.from(
            new Set(loanList.map((item) => item.billNo))
          )
          loanList.forEach((item) => {
            const { billNo } = item
            if (!this.loanListMap[billNo]) {
              this.loanListMap[billNo] = []
            }
            this.loanListMap[billNo].push(item)
          })
          if (this.loanList?.length) {
            this.loanPlatform = this.loanList[0].loanPlatform
          }
          sessionStorage.removeItem('repayOrderSelect')
          sessionStorage.removeItem('repayExpenseSelect')
          return
        }
        // sessionStorage 如果有缓存的值 则用这个值 没有就默认全部勾选
        const store = JSON.parse(sessionStorage.getItem('repayOrderSelect'))
        const storeRightSelected = JSON.parse(
          sessionStorage.getItem('repayExpenseSelect')
        )
        // 如果缓存里面有权益订单，那么用缓存的值
        if (storeRightSelected) {
          this.repayExpenseSelect = storeRightSelected
        } else if (selectConsume === 'Y' && rightsList?.length) {
          // 如果默认勾选权益，那么这里把权益的全部存入缓存
          sessionStorage.setItem(
            'repayExpenseSelect',
            JSON.stringify(rightsList)
          )
          this.repayExpenseSelect = rightsList
        }

        // 如果缓存里面有值，那么用缓存的值 没有默认全部勾选
        if (store) {
          this.selectedList = store
        } else {
          this.selectedList = loanList
        }
        this.loanList = loanList
        this.rightsList = rightsList

        if (this.loanList?.length) {
          this.loanPlatform = this.loanList[0].loanPlatform
        }

        this.billNoList = Array.from(
          new Set(loanList.map((item) => item.billNo))
        )

        loanList.forEach((item) => {
          const { billNo } = item
          if (!this.loanListMap[billNo]) {
            this.loanListMap[billNo] = []
          }
          this.loanListMap[billNo].push(item)
        })
      }
    },
    fillZero (num) {
      return num < 10 ? '0' + num : num
    },
    confirm () {
      this.storeList()
      this.$router.push('/quickRepay/confirm')
    },
    pushRightsList () {
      if (this.repaying) return
      this.storeList()
      this.$router.push('/quickRepay/rightsList')
    },
    storeList () {
      sessionStorage.setItem(
        'repayOrderSelect',
        JSON.stringify(this.selectedList)
      )
      sessionStorage.setItem(
        'repayExpenseSelect',
        JSON.stringify(this.repayExpenseSelect)
      )
    },
    selectAll () {
      this.repayExpenseSelect = JSON.parse(
        sessionStorage.getItem('repayExpenseSelect') || '[]'
      )
      // 1. 判断当前是否有选中项
      if (this.isAllSelect) {
        this.selectedList = []
        this.repayExpenseSelect = []
        sessionStorage.removeItem('repayExpenseSelect')
        return
      }
      this.selectedList = this.loanList
      this.repayExpenseSelect = this.rightsList
      sessionStorage.setItem(
        'repayExpenseSelect',
        JSON.stringify(this.rightsList)
      )
    },
    changeSelect (item) {
      const { billNo, term, billStatus } = item
      const firstItem = this.loanListMap[billNo][0]
      const index = this.loanListMap[billNo].findIndex(
        (item) => item.term === term
      )
      const selectedItem = this.selectedList.find(
        (item) => item.billNo === billNo && item.term === term
      )

      // 1. 判断已选择列表里面是否已经有当前选项
      if (selectedItem) {
        // 取消逻辑 判断是否有跳期
        // 判断当前期的后面所有期供是否都已经取消
        const thisBillListTerm =
          this.loanListMap[billNo].map((i) => i.term).filter((i) => i > term) ||
          []

        if (thisBillListTerm?.length) {
          const selectedListTerm = this.selectedList.some((i) => {
            return i.billNo === billNo && thisBillListTerm.includes(i.term)
          })
          if (selectedListTerm) {
            this.$message('请顺次取消还款期数')
            return
          }
        }

        this.selectedList = this.selectedList.filter(
          (item) => item.billNo !== billNo || item.term !== term
        )
      } else {
        // 2. 如果没有，判断当前期供是否是第一期

        if (firstItem.term === term) {
          this.selectedList.push(item)
        } else {
          // 判断当前期的上一期是否已经加入进去

          const preTerm = this.loanListMap[billNo][index - 1]
          if (preTerm) {
            const _selectedList =
              this.selectedList.filter(
                (item) => item.billNo === billNo && item.term === preTerm.term
              ) || []
            const selectedPreItem = _selectedList.find(
              (item) => item.term === preTerm.term
            )

            if (!selectedPreItem) {
              this.$message('请顺次选择还款期数')
              // 判断当前订单是否逾期 如果逾期那么勾选当前订单的所有期供
              if (billStatus === 'O') {
                this.selectedList = this.selectedList.filter(
                  (item) => item.billNo !== billNo
                )
                this.loanListMap[billNo].forEach((item) => {
                  this.selectedList.push(item)
                })
              }
              return
            }
          }

          this.selectedList.push(item)
        }
      }
    },
    isSelected (item) {
      const { billNo, term } = item
      const selectedItem = this.selectedList.find(
        (item) => item.billNo === billNo && item.term === term
      )
      return !!selectedItem
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #fafafa;
  position: relative;

  .control-container {
    background: #fff;
    width: 10rem;
    height: 180px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    .flex {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    span {
      font-size: 28px;
      font-weight: bold;
    }
    .next-btn {
      width: 320px;
      height: 94px;
      line-height: 94px;
      margin-right: -10px;
    }

    .pending-btn {
      width: 100%;
      height: 94px;
      line-height: 94px;
      margin: 0 30px;
    }
  }

  .ui-select {
    width: 32px;
    height: 32px;
    background: url("./images/circle_01@2x.png") no-repeat center;
    background-size: 100%;

    &.selected {
      background-image: url("./images/circle_03@2x.png");
    }
  }

  .main-container {
    width: 750px;
    padding: 0 30px;
    padding-bottom: 200px;

    .order-list {
      background: #fff;
      border-radius: 20px;
      margin-top: 20px;

      .ui-select {
        margin: 0 -30px;
      }

      .orderNo {
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #999999;
        padding-left: 20px;
        border-bottom: 1px solid #eee;
      }

      .order-item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 30px 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #333333;

        & .innerItem:last-child {
          text-align: right;
          width: 120px;
        }

        & .danger {
          color: #fb4a46;
        }
        & .WAIT {
          color: #333;
        }
        & .IN_PROGRESS {
          color: #4b94f0;
        }
        & .SUCCESS,.PART {
          color: #999;
        }
      }
    }
  }

  .rights-item {
    display: flex;
    align-items: center;
    gap: 10px;

    .rights-item-select {
      width: 32px;
      height: 32px;
      background: url("./images/circle_01@2x.png") no-repeat center;
      background-size: 100%;

      &.selected {
        background-image: url("./images/circle_02@2x.png");
      }
    }
  }

  .rights-container {
    margin-top: 20px;
    width: 100%;
    height: 110px;
    background: url(./images/banner_sanfang@2x.png) no-repeat center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #333333;
  }

  .title {
    margin-top: 20px;

    .title-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #333333;
    }

    .title-desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      margin-top: 15px;
      color: #999999;
    }
  }
}
</style>
